import { GridColDef } from '@mui/x-data-grid';
import { SystemNotificationInterface } from '../../../interfaces/interfaces';

export const getSystemNotificationsColumns = (): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'adSpaceId', headerName: 'Ad Space ID', width: 110 },
  { field: 'notificationType', headerName: 'Type', width: 140 },
  { field: 'notificationMessage', headerName: 'Message', width: 250 },
  { field: 'threadId', headerName: 'Thread ID', width: 120 },
  { field: 'recipientUserId', headerName: 'Recipient User ID', width: 130 },
  { field: 'fromUserId', headerName: 'From User ID', width: 120 },
  { field: 'broadcast', headerName: 'Broadcast', width: 100, type: 'boolean' },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'metaData',
    headerName: 'Meta Data',
    width: 180,
    valueGetter: (params: any) => {
      const row = params?.row as SystemNotificationInterface | undefined;
      return row && row.metaData ? JSON.stringify(row.metaData) : '';
    },
  },
];